<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <story-image :src="require(`@/assets/images/pics/第1章_3-1_彰化車站.jpg`)" size="lg"></story-image>
              <!-- （圖片：彰化車站照片） -->

              <npc :npc-id="1" right>說起來，這個小逸堂是怎樣的地方呢？</npc>
              <npc :npc-id="0">這個嘛，其實是已經不存在的地方。</npc>
              <npc :npc-id="1" right>不存在的地方？</npc>
              <npc :npc-id="0">小逸堂是以前彰化的私塾，漢學堂，賴和曾經在小逸堂讀書，現在學堂被拆掉了，只剩下旁邊的『南山寺』。</npc>
              <npc :npc-id="1" right>喔喔，原來如此。所以『無可取代的記憶』就是漢學堂的回憶？不過上學這種事不都千篇一律，有什麼無可取代的？</npc>
              <npc :npc-id="0">嗯～～一般人確實是這麼想吧？但對賴和先生來說，回憶不只是學校，還有他的同學們喔；他跟這些同學當了一輩子的好朋友，直到年老都還有辦同學會！</npc>
              <npc :npc-id="1" right>欸？但賴和後來考上醫學校，離鄉背井到臺北唸書了，怎麼跟家鄉同學關係還這麼好？</npc>
              <npc :npc-id="0">之後賴和先生還是回到彰化啦！說到這個，其實有件逸事很有趣，是賴和先生在醫學校時期的事。有一次，他跟同學杜聰明——</npc>
              <npc :npc-id="1" right>等一下，你說杜聰明？臺灣第一位醫學博士？這個人連我都認識耶！他跟賴和是同學？</npc>
              <npc :npc-id="0">對，先讓我說完嘛！那次賴和先生不知為什麼，居然跟杜聰明從臺北徒步走到彰化，走了六天五夜，一路上還寫了二十幾首詩記錄這段旅程，但這件事引起了小逸堂的同學詹作舟的不滿。</npc>
              <npc :npc-id="1" right>為什麼？</npc>
              <npc :npc-id="0">因為詹作舟也考上醫學校，是那兩位的同學。明明是同學，家鄉也在彰化，可以同行，為什麼賴和先生跟杜聰明居然偷跑不等他？所以他忍不住抱怨。</npc>
              <npc :npc-id="1" right>哈哈哈，原來如此，如果是我也會問為什麼不等我啊！不過真意外，想不到賴和有這樣的面向耶。</npc>
              <npc :npc-id="0">怎樣的面向啦？賴和先生也是人，當然也有普通的日常生活啊。</npc>
              <npc :npc-id="1" right>不是啦，但通常說到賴和，不都會想到〈一桿秤仔〉之類的嗎？就是那種憤怒抗議的印象。</npc>
              <npc :npc-id="0">原來如此，不過人本來就有不同面向，這也很正常；總之，小逸堂確實對賴和先生來說確實深具意義，不只是同學會，平常也會跟這些同學寫詩唱和，這樣深厚的情誼，實在是很罕見——我們快到囉！南山寺，小逸堂的舊址就在那裡。</npc>
              <npc :npc-id="1" right>等等，好像有什麼不對勁？</npc>

              <story-image :src="require(`@/assets/images/pics/第1章_3-2_南山寺奇異照片.jpg`)" size="lg"></story-image>
              <!-- （圖片：南山寺的照片） -->

              <npc :npc-id="1" right>這、這是！？</npc>
              <npc :npc-id="0">這是怎麼回事！時間被偷走了？這裡有個時間的空洞——</npc>
              <npc :npc-id="1" right>這是時間隧道？對面的人能看到我們嗎？</npc>
              <npc :npc-id="0">不，不是。只是單純偷走了一塊時間，就像挖冰淇淋一樣⋯⋯對面無法看到我們，因為過去無法窺探未來，只有未來能看見過去。</npc>
              <npc :npc-id="1" right>所以怪盜只偷走一部分區域的時間？怎麼可能！</npc>
              <npc :npc-id="0">我也覺得不可能，但有人做到了。</npc>
              <npc :npc-id="1" right>為什麼要這麼做！？</npc>
              <npc :npc-id="0">『無可取代的回憶』⋯⋯</npc>
              <npc :npc-id="1" right>你是說，怪盜偷走了賴和的回憶？</npc>
              <npc :npc-id="0">不，怪盜是偷走了賴和先生在小逸堂的時間！</npc>
              <npc :npc-id="1" right>什麼？</npc>
              <npc :npc-id="0">你看，對面是賴和先生就讀小逸堂之前啊！他把賴和先生在小逸堂的時間消除了，可惡的怪盜，還真做得出這種事！</npc>
              <npc :npc-id="1" right>呂善安，你看！這是怪盜留下的紙條嗎？</npc>
              <npc :npc-id="0">『呂善安君，欲取回回憶，問南山寺山門象之數，以此數平均敲擊石獅』。這是⋯⋯</npc>
              <npc :npc-id="1" right>咦？那怪盜認識你嗎？難道你們是熟人？</npc>
              <npc :npc-id="0">比起這個，知道來的是我不是更奇怪嗎？⋯⋯不，難道他一開始就知道臺灣文學館會來委託我？先不管這個，顯然怪盜留下了一個簡單的謎題給我們。</npc>
              <npc :npc-id="1" right>謎題？</npc>
              <npc :npc-id="0">嗯。後面這段話，就是取回『被偷走的時間』的條件吧？看來只能照辦了。</npc>
              <npc :npc-id="1" right>等一下，你不怕有陷阱嗎？</npc>
              <npc :npc-id="0">八成有吧！</npc>
              <npc :npc-id="1" right>那你還要照辦！？</npc>
              <npc :npc-id="0">不入虎穴，焉得虎子，總不能放著消失的回憶不管吧？那麼，謎題是如何呢？南山寺前有兩隻石獅，也就是清點山門上『大象』的數量，再輪流敲打石獅吧？這樣的話，我們該做的是——</npc>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="南山寺前有兩隻石獅，那麼山門上『大象』的數量是多少呢？" morehint="這是除法題，象之數÷石獅之數=？">
              <p>欲取回回憶，問南山寺山門象之數，以此數平均敲擊石獅。請問一隻石獅要被敲多少下？（請輸入阿拉伯數字）</p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage1_3',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第一章 - 3',
      isQuestion: true,
      stageId: 'time',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
